/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetBulkWriteSummaryResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetBulkWriteSummaryResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/bulk-writes
 */
export interface BulkWritesRequestBuilder extends BaseRequestBuilder<BulkWritesRequestBuilder> {
    /**
     * Returns how many bulk calls the organization's integrations made and how many documents they sent, per endpoint per UTC day, over a window (defaults to the last 30 days). Every call to a bulk endpoint counts once, with the number of documents it carried, whether or not the call succeeded — failed calls are reported separately. Dividing a day's document count by the organization's real document count gives its write-amplification ratio: an integration that re-sends its whole catalog every run shows up here as a ratio well above 1 before it shows up as a slow database.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetBulkWriteSummaryResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<BulkWritesRequestBuilderGetQueryParameters> | undefined) : Promise<GetBulkWriteSummaryResponse | undefined>;
    /**
     * Returns how many bulk calls the organization's integrations made and how many documents they sent, per endpoint per UTC day, over a window (defaults to the last 30 days). Every call to a bulk endpoint counts once, with the number of documents it carried, whether or not the call succeeded — failed calls are reported separately. Dividing a day's document count by the organization's real document count gives its write-amplification ratio: an integration that re-sends its whole catalog every run shows up here as a ratio well above 1 before it shows up as a slow database.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<BulkWritesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns how many bulk calls the organization's integrations made and how many documents they sent, per endpoint per UTC day, over a window (defaults to the last 30 days). Every call to a bulk endpoint counts once, with the number of documents it carried, whether or not the call succeeded — failed calls are reported separately. Dividing a day's document count by the organization's real document count gives its write-amplification ratio: an integration that re-sends its whole catalog every run shows up here as a ratio well above 1 before it shows up as a slow database.
 */
export interface BulkWritesRequestBuilderGetQueryParameters {
    /**
     * Start of the window (inclusive). Defaults to 30 days before the end when omitted.
     */
    from?: Date;
    /**
     * End of the window (exclusive). Defaults to now when omitted.
     */
    to?: Date;
}
/**
 * Uri template for the request builder.
 */
export const BulkWritesRequestBuilderUriTemplate = "{+baseurl}/api/organizations/bulk-writes{?from*,to*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const BulkWritesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: BulkWritesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetBulkWriteSummaryResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
